import { StateModel } from '../redux/models/state.model';

enum ActiveViewType {
  dialog = 'dialog',
  sidebar = 'sidebar',
  page = 'page',
  window = 'window',
}

/** Функция выполняющая диспатчи в зависимости от порядка - сначала диалоги, потом сайдбары, потом модалки **/
export const dispatchByActiveView = (
  getState: () => StateModel,
  handlers: Partial<Record<ActiveViewType, () => void>>,
) => {
  const state = getState();

  if (state.windowViewState?.viewParams) return handlers[ActiveViewType.window]();
  else if (state.dialogViewsState.length > 0) handlers[ActiveViewType.dialog]();
  else if (state.sidebarViewsState.length > 0) return handlers[ActiveViewType.sidebar]();
  else handlers[ActiveViewType.page]();
};
